import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

const stored = localStorage.getItem("gbc_token") || sessionStorage.getItem("gbc_token");
if (stored) api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;

export const setToken = (token, remember = true) => {
  if (token) {
    // "Remember Me": persist in localStorage; otherwise keep only for the tab session.
    if (remember) {
      localStorage.setItem("gbc_token", token);
      sessionStorage.removeItem("gbc_token");
    } else {
      sessionStorage.setItem("gbc_token", token);
      localStorage.removeItem("gbc_token");
    }
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("gbc_token");
    sessionStorage.removeItem("gbc_token");
    delete api.defaults.headers.common["Authorization"];
  }
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
